import { useEffect } from "react";
import { Navigation } from "../cmps/homepage/navigation";
import { HeroSection } from "../cmps/homepage/hero-section";
import { ProblemSection } from "../cmps/homepage/problem-section";
import { HowItWorksSection } from "../cmps/homepage/how-it-works-section";
import { ServicesSection } from "../cmps/homepage/services-section";
import { IndustriesSection } from "../cmps/homepage/industries-section";
import { BenefitsSection } from "../cmps/homepage/benefits-section";
import { TestimonialsSection } from "../cmps/homepage/testimonials-section";
import { CtaSection } from "../cmps/homepage/cta-section";
import { FooterSection } from "../cmps/homepage/footer-section";

export default function LandingPage() {
  useEffect(() => {
    document.title = "MANAGE ME - Independent Project Oversight";
  }, []);

  return (
    <div className="homepage-root">
      <main className="relative min-h-screen overflow-x-hidden">
        <Navigation />
        <HeroSection />
        <ProblemSection />
        <HowItWorksSection />
        <ServicesSection />
        <IndustriesSection />
        <BenefitsSection />
        <TestimonialsSection />
        <CtaSection />
        <FooterSection />
      </main>
    </div>
  );
}
